import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CreateRequestModalService {
  // ReplaySubject to cache the last signal for late subscribers
  private readonly openCreateModalSubject = new ReplaySubject<void>(1);
  public readonly openCreateModal$ = this.openCreateModalSubject.asObservable();

  /**
   * Trigger the create request modal to open.
   * Called after external auth redirects to /requests page.
   */
  triggerOpenModal(): void {
    this.openCreateModalSubject.next();
  }
}
